// assets/custom.js
console.log('🔥 custom.js caricato');
(function() {
  // prendiamo l'header con id o classe
  const header = document.getElementById('header') || document.querySelector('.header');
  if (!header) return;

  let lastY = window.scrollY;
  header.classList.toggle('vf-header-scrolled', window.scrollY > 40);
  if (window.innerWidth <= 768) header.classList.toggle('header--hidden', window.scrollY > 0);

  window.addEventListener('scroll', function() {
    const currentY = window.scrollY;
    header.classList.toggle('vf-header-scrolled', currentY > 40);
    if (window.innerWidth <= 768) {
      header.classList.toggle('header--hidden', currentY > 0);
    } else if (currentY > lastY && currentY > 20) {
      // scroll down: nascondi
      header.classList.add('header--hidden');
    } else {
      // scroll up o top: mostra
      header.classList.remove('header--hidden');
    }
    lastY = currentY;
  }, { passive: true });
})();


// assets/custom.js
document.addEventListener('DOMContentLoaded', function() {
  // applichiamo solo su schermi <= 768px
  if (window.innerWidth > 768) return;

  // selettore del tuo header fisso (pill-shaped)
  var header = document.querySelector('theme-header#header.header') 
               || document.querySelector('.header');

  if (!header) return;

  // misura l'altezza effettiva
  var h = header.getBoundingClientRect().height;

  // aggiunge padding-top al primo wrapper dopo il header
  var first = header.nextElementSibling;
  if (first) {
    first.style.paddingTop = h + 'px';
  }
});

document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-section-suffix]');
  if (!link) return;

  const suffix = link.dataset.sectionSuffix;
  const target = document.querySelector('[id$="' + CSS.escape(suffix) + '"]');
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  history.replaceState(null, '', '#' + target.id);
});
